import { css } from '@emotion/react';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import type { NonInteractiveSlotCalendarEvent } from '../../../types';

dayjs.extend(customParseFormat);

interface Props {
  event: NonInteractiveSlotCalendarEvent;
}

export const NonInteractiveSlotEvent = ({ event }: Props) => {
  const [dayTime, dayPeriod] = dayjs(event.startTime, 'HH:mm').format('h:mm A').split(' ');

  return (
    <div css={containerStyle}>
      <div css={wrapperStyle}>
        <Text as='span' weight='bold' size='small'>
          {dayTime}
        </Text>
        {!!dayPeriod && (
          <Text as='span' weight='bold' size='small'>
            {dayPeriod}
          </Text>
        )}
      </div>
    </div>
  );
};

const wrapperStyle = css({
  margin: theme.spacing(0, 0.5),
  padding: theme.spacing(0.5, 0),
  borderRadius: theme.borderRadius.small,
  border: `1px solid ${theme.colors.neutral60}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(0.5),
});

const containerStyle = css({
  containerType: 'inline-size',
  '@container (width < 80px)': {
    div: { margin: 0 },
  },
  '@container (width < 60px)': {
    'span:last-child': {
      display: 'none',
    },
  },
});
